import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";

//import ProgressBar from "ia.react.progressbar";

import ProgressBarTemp from "./ProgressBarTemp";

export class Header extends Component {
  constructor(props) {
    super();
  }

  createHeader = step => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Row>
          <Col sm="6">
            <ProgressBarTemp
              currentStepIndex={step}
              steps={["#", "#", "#", "#", "#", "#", "#"]}
              lang={this.props.lang}
            />
          </Col>
          <Col sm={{ size: "5", offset: "1" }}>
            <br />
            <p>
              {t("common.help")} <br />
              {t("common.call")}{" "}
              <a href="tel:18005497227">
                <u>{t("common.phone")}</u>
              </a>
            </p>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>{this.createHeader(this.props.step)}</React.Fragment>
    );
  }
}

export default translate("translate")(Header);
